import React from 'react'

const OurBlogData =  [
{
    id: 1,
    image: 'images/blog/1.jpeg',
    imageTitle: 'Lorem',
    title: 'Lorem Ipsum',
    detail: 'Lorem ipsum dolor sit amet consectetur. Dignissim venenatis urna gravida elit.',
},
{
    id: 2,
    image: 'images/blog/2.jpeg',
    imageTitle: 'Lorem',
    title: 'Lorem Ipsum',
    detail: 'Lorem ipsum dolor sit amet consectetur. Dignissim venenatis urna gravida elit.',
},
{
    id: 3,
    image: 'images/blog/3.jpeg',
    imageTitle: 'Lorem',
    title: 'Lorem Ipsum',
    detail: 'Lorem ipsum dolor sit amet consectetur. Dignissim venenatis urna gravida elit.',
},

]
export default OurBlogData